import {ApiFunctions} from '@mintdata-wsp/common/controllers/spreadsheet/functions/ApiFunctions';
import {AuthFunctions} from '@mintdata-wsp/common/controllers/spreadsheet/functions/AuthFunctions';
import {CacheFunctions} from '@mintdata-wsp/common/controllers/spreadsheet/functions/CacheFunctions';
import {CellFunctions} from '@mintdata-wsp/common/controllers/spreadsheet/functions/CellFunctions';
import {DateFunctions} from '@mintdata-wsp/common/controllers/spreadsheet/functions/DateFunctions';
import {DnDFunctions} from '@mintdata-wsp/common/controllers/spreadsheet/functions/DnDFunctions';
import {ExtractFunctions} from '@mintdata-wsp/common/controllers/spreadsheet/functions/ExtractFunctions';
import {FileFunctions} from '@mintdata-wsp/common/controllers/spreadsheet/functions/FileFunctions';
// import {FinancialFunctions} from '@mintdata-wsp/common/controllers/spreadsheet/functions/FinancialFunctions';
import {FramesFunctions} from '@mintdata-wsp/common/controllers/spreadsheet/functions/FramesFunctions';
import {JsonFunctions} from '@mintdata-wsp/common/controllers/spreadsheet/functions/JsonFunctions';
import {LogicalFunctions} from '@mintdata-wsp/common/controllers/spreadsheet/functions/LogicalFunctions';
import {LookupFunctions} from '@mintdata-wsp/common/controllers/spreadsheet/functions/LookupFunctions';
import {MathFunctions} from '@mintdata-wsp/common/controllers/spreadsheet/functions/MathFunctions';
import {StreamingFunctions} from '@mintdata-wsp/common/controllers/spreadsheet/functions/StreamingFunctions';
import {SurfaceFunctions} from '@mintdata-wsp/common/controllers/spreadsheet/functions/SurfaceFunctions';
import {TableFunctions} from '@mintdata-wsp/common/controllers/spreadsheet/functions/TableFunctions';
import {TestFunctions} from '@mintdata-wsp/common/controllers/spreadsheet/functions/TestFunctions';
import {TextFunctions} from '@mintdata-wsp/common/controllers/spreadsheet/functions/TextFunctions';
import {TimerFunctions} from '@mintdata-wsp/common/controllers/spreadsheet/functions/TimerFunctions';
import {WebFunctions} from '@mintdata-wsp/common/controllers/spreadsheet/functions/WebFunctions';
import {FunctionContainerCtor} from '@mintdata-wsp/common/state/ui/visualDesigner/spreadsheet/ClientFunction';
import {IContextMenuItem} from '@mintdata/mint-kit/impl/components/contextMenu/ContextMenu';

export enum FunctionsMenuItemType
{
    Function = 'Function',
    Group = 'Group',
    SingleItem = 'SingleItem',
    Separator = 'Separator',
}

export interface IFunctionsMenuItem extends IContextMenuItem
{
    id?:string,
    type:FunctionsMenuItemType,
    funcName?:string,
    tip?:string,
    functions?:Array<FunctionContainerCtor>
    items?:Array<IFunctionsMenuItem>
}

export const FunctionsMenuItems:Array<IFunctionsMenuItem> = [
    {
        label: 'SUM',
        funcName: 'sum',
        type: FunctionsMenuItemType.Function,
    },
    {
        label: 'AVERAGE',
        funcName: 'average',
        type: FunctionsMenuItemType.Function,
    },
    {
        label: 'COUNT',
        funcName: 'count',
        type: FunctionsMenuItemType.Function,
    },
    {
        label: 'MAX',
        funcName: 'max',
        type: FunctionsMenuItemType.Function,
    },
    {
        label: 'MIN',
        funcName: 'min',
        type: FunctionsMenuItemType.Function,
    },
    {
        type: FunctionsMenuItemType.Separator,
    },
    {
        label: 'All',
        type: FunctionsMenuItemType.Group,
        functions: [
            TestFunctions,
            MathFunctions,
            WebFunctions,
            AuthFunctions,
            CellFunctions,
            TimerFunctions,
            // FinancialFunctions,
            ExtractFunctions,
            TextFunctions,
            JsonFunctions,
            FileFunctions,
            FramesFunctions,
            CacheFunctions,
            LogicalFunctions,
            DateFunctions,
            LookupFunctions,
            StreamingFunctions,
            SurfaceFunctions,
            DnDFunctions,
            TableFunctions,
            ApiFunctions
        ],
    },
    {
        // label: 'Test',
        type: FunctionsMenuItemType.Group,
        functions: [TestFunctions],
    },
    {
        // label: 'Math',
        type: FunctionsMenuItemType.Group,
        functions: [MathFunctions],
    },
    {
        // label: 'Web',
        type: FunctionsMenuItemType.Group,
        functions: [WebFunctions],
    },
    {
        // label: 'Auth',
        type: FunctionsMenuItemType.Group,
        functions: [AuthFunctions],
    },
    {
        // label: 'Cell',
        type: FunctionsMenuItemType.Group,
        functions: [CellFunctions],
    },
    {
        // label: 'Timer',
        type: FunctionsMenuItemType.Group,
        functions: [TimerFunctions],
    },
    // {
    //     // label: 'Financial',
    //     type: FunctionsMenuItemType.Group,
    //     functions: [FinancialFunctions],
    // },
    {
        // label: 'Extract ???',
        type: FunctionsMenuItemType.Group,
        functions: [ExtractFunctions],
    },
    {
        // label: 'Text',
        type: FunctionsMenuItemType.Group,
        functions: [TextFunctions],
    },
    {
        // label: 'Json',
        type: FunctionsMenuItemType.Group,
        functions: [JsonFunctions],
    },
    {
        // label: 'File',
        type: FunctionsMenuItemType.Group,
        functions: [FileFunctions],
    },
    {
        // label: 'Frames',
        type: FunctionsMenuItemType.Group,
        functions: [FramesFunctions],
    },
    {
        // label: 'Cache',
        type: FunctionsMenuItemType.Group,
        functions: [CacheFunctions],
    },
    {
        // label: 'Logical',
        type: FunctionsMenuItemType.Group,
        functions: [LogicalFunctions],
    },
    {
        // label: 'Date',
        type: FunctionsMenuItemType.Group,
        functions: [DateFunctions],
    },
    {
        // label: 'Lookup',
        type: FunctionsMenuItemType.Group,
        functions: [LookupFunctions],
    },
    {
        // label: 'Streaming',
        type: FunctionsMenuItemType.Group,
        functions: [StreamingFunctions],
    },
    {
        // label: 'Surface',
        type: FunctionsMenuItemType.Group,
        functions: [SurfaceFunctions],
    },
    {
        // label: 'Table',
        type: FunctionsMenuItemType.Group,
        functions: [TableFunctions],
    },
    {
        // label: 'Api',
        type: FunctionsMenuItemType.Group,
        functions: [ApiFunctions],
    },
    {
        type: FunctionsMenuItemType.Separator,
    },
    // added in menu provider
    // {
    //     label: 'Learn more',
    //     type: FunctionsMenuItemType.SingleItem,
    // },
];
